export const ROUTES = {
  Index: '/',
  // v3
  // undress
  QuizV4: '/v4',
  QuizV4Welcome: '/v4/welcome',
  QuizV4Instruction: '/v4/instruction',
  QuizV4Generation: '/v4/generation',
  QuizV4Result: '/v4/result',
  // undress with drawing
  QuizV5: '/v5',
  QuizV5Welcome: '/v5/welcome',
  QuizV5Instruction: '/v5/instruction',
  QuizV5Generation: '/v5/generation',
  QuizV5Result: '/v5/result',
  //
  Email: '/email',
  Paywall: '/paywall',
  Success: '/success',
  Failed: '/failed',
  Instruction: '/instruction',
  DownloadApp: '/download-app',
  FAQ: 'https://intercom.help/wndr11/en/',
  ImgnFun: 'https://quiz.imagin8.fun/',
  ShortPayment: '/short-payment',
};
